var map = {
	"./bazar.png": 10949,
	"./enamad.png": 98683,
	"./footerLogo.jpg": 23446,
	"./googlePlay.svg": 75699,
	"./iso.jpg": 61650,
	"./iso.png": 21616,
	"./logo.png": 15080,
	"./mayket.svg": 44828,
	"./samandehi.png": 79768,
	"./web home 2022.jpg": 93645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;